module.exports = __webpack_public_path__ + "img/jaroussky.f428d7bc.jpg";